import React from 'react';
import './Banner.scss'


const Banner = ({title, subtitle}) =>
    <div className="header-banner">
        <div className="container">
            <h2>{title}</h2>
            <p>{subtitle}</p>
        </div>
    </div>

export default Banner;


// WEBPACK FOOTER //
// ./src/Components/Banner.js